import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

class SaveButton extends Component {
  buttonText() {
    const { saving, action } = this.props;

    if (saving) {
      return "Saving...";
    }

    if (action === "show") {
      return "Edit";
    }

    return "Save";
  }

  render() {
    return (
      <Button
        size="sm"
        onClick={() => this.props.toggleAction()}
        disabled={this.props.saving}
        className="save-button">
        {this.buttonText()}
      </Button>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    action: state.ui.action,
    saving: state.ui.saving
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleAction: () => dispatch({ type: "TOGGLE_ACTION" })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveButton);
